<!-- The core Firebase JS SDK is always required and must be listed first -->
<script src="/__/firebase/7.15.1/firebase-app.js"></script>

<!-- TODO: Add SDKs for Firebase products that you want to use
     https://firebase.google.com/docs/web/setup#available-libraries -->
<script src="/__/firebase/7.15.1/firebase-analytics.js"></script>

<!-- Initialize Firebase -->
<script src="/__/firebase/init.js"></script>

<!-- WhatsApp Widget -->
<script async data-id="52875" src="https://cdn.widgetwhats.com/script.min.js"></script>

<template>
  <div id="app">
    <div id="nav">
      <navBar> </navBar>
    </div>
    <div id="cont">
      <router-view />
    </div>   
    <div id="footer">
      <foot></foot>
    </div>    
  </div>
</template>

<style lang="scss">
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;

  //hacer que siempre esté hasta abajo el footer
  min-height: 70%;
  min-height: -webkit-calc(100% - 186px);
  min-height: -moz-calc(100% - 186px);
  min-height: calc(100% - 186px);
}

.column {
  text-align: justify;
}
h1 {
  @media screen and (max-width: 500px) {
    font-size: 35px !important;
  }
}
b {
  color: #9ed96b;
}
.cont {
  padding-top: 95px;
}
#nav {
  a {
    font-size: 12px;
    font-family: 'Open Sans', sans-serif;
    color: #0d0635;
    text-decoration: none;
    &.router-link-exact-active {
      text-decoration: underline;
      color: #095168;
    }

  }
}
</style>

<script>
import NavBar from "@/components/NavBar.vue";
import Foot from "@/components/Foot.vue";

export default {
  name: "App",
  components: {
    NavBar: NavBar,
    Foot: Foot,
  },
};
</script>

